import Image from "next/image";
import clsx from "clsx";

const TYPE_TO_CLASS = {
  danger: "bg-red-900 text-red",
  info: "bg-blue-800 text-blue",
  success: "bg-green-800 text-green",
};

const Alert = ({ type = "danger", children, className }) => (
  <div className={clsx(" flex items-center p-4 mb-4 space-x-3 w-full rounded-md", TYPE_TO_CLASS[type], className)}>
    <div className="flex flex-shrink-0">
      <Image src={`/alert/${type}.svg`} alt="Alert" width={20} height={20} />
    </div>
    <span className="text-sm whitespace-pre-line">{children}</span>
  </div>
);

export default Alert;
